import { css } from '@linaria/core';
import { Root as ButtonRoot } from '../Button/styles';
export const Root = {
    base: css `
		position: relative;
		z-index: 1;

		width: 100%;
		margin: 0;
		padding: 0;

		.swiper {
			width: auto;

			.swiper-slide {
				width: auto;
			}
		}
	`,
    alignment: {
        left: undefined,
        center: css `
			.swiper:not(.swiper-initialized) {
				.swiper-wrapper {
					display: flex;
					justify-content: center;
				}
			}
		`,
        right: undefined,
    },
};
export const ButtonElement = {
    base: css `
		@keyframes cs-Navbar-Pulse {
			0% {
				opacity: 0.75;
			}
			100% {
				opacity: 1;
			}
		}
	`,
    isLoading: css `
		.${ButtonRoot.base} {
			min-width: 100px;
			animation: cs-Navbar-Pulse 600ms 200ms var(--global-ease-in-out) infinite;
			animation-direction: alternate-reverse;
		}
	`,
};
export const ButtonWrapper = {
    base: css `
		position: relative;
		z-index: 1;

		display: inline-flex;

		margin: 0;
		padding: 0;

		list-style-type: none;

		.${ButtonRoot.base} {
			&[type='pill'],
			&[type='fill'] {
				margin-right: 4px;
			}
		}
	`,
    alignment: {
        left: css `
			display: flex;
			justify-content: flex-start;
			width: 100%;
		`,
        center: css `
			display: flex;
			justify-content: center;
		`,
        right: css `
			display: flex;
			justify-content: flex-end;

			.${ButtonRoot.base} {
				&[type='pill'],
				&[type='fill'] {
					margin-right: 0;
					margin-left: 4px;
				}
			}
		`,
    },
};
